module.exports = __webpack_public_path__ + "static/media/radio-button-not-selected.4557d08d.svg";